import Component, { mixins } from 'vue-class-component'

import Localization from '@/localization';
import { generateLocalizedRouteName } from '@/router/helpers';

export interface IRouterMixin {
  mixin_router_navigate(route: any): void;
  mixin_router_generateHref(route: any): string;
}

@Component
export default class RouterMixin extends mixins() implements IRouterMixin {
  public mixin_router_navigate(route: any): void {
    if (!route) {
      throw new Error("Unable to mixin_router_navigate. Route not provided.")
    }

    this.$router.push({
      ...route,
      name: generateLocalizedRouteName({
        name: route.name as string,
        locale: Localization.CURRENT_LOCALE
      })
    })
  }

  public mixin_router_generateHref(route: any): string {
    if (!route) {
      throw new Error("Unable to mixin_router_generateHref. Route not provided.")
    }

    return this.$router.resolve({
      ...route,
      name: generateLocalizedRouteName({
        name: route.name as string,
        locale: Localization.CURRENT_LOCALE
      })
    }).href
  }
}
